import around12 from "../../assets/bodyFat/12.png"
import around25 from "../../assets/bodyFat/25.png"
import around35 from "../../assets/bodyFat/35.png"
import around40 from "../../assets/bodyFat/40.png"
import above45 from "../../assets/bodyFat/40+.png"

import female10 from "../../assets/bodyFat/10F.jpg"
import female20 from "../../assets/bodyFat/20F.jpg"
import female35 from "../../assets/bodyFat/35F.png"
import female40 from "../../assets/bodyFat/40F.png"
import female45 from "../../assets/bodyFat/45F.png"

export const bodyFatMale =[
    {
        id:1,
        text: "Above 45%",
        img:above45,
        data:45,
        position: '100% 50%'
    },
    {
        id:2,
        text: "Around 40%",
        img:around40,
        data: 40,
        position: '100% 40%'
    },
    {
        id:3,
        text: "Around 35%",
        img:around35,
        data: 35,
        position: '100% 60%'
    },
    {
        id:4,
        text: "Around 25%",
        img:around25,
        data: 25,
        position: '100% 10%'
    },
    {
        id:5,
        text: "Around 12%",
        img:around12,
        data: 12,
        position: '100% 60%'
    },
    
]
export const bodyFatFemale =[
    {
        id:1,
        text: "+ 45%",
        img:female45,
        data: 45,
        position: '100% 15%'
    },
    {
        id:2,
        text: "Around 40%",
        img:female40,
        data: 40,
        position: '100% 15%'
    },
    {
        id:3,
        text: "Around 35%",
        img:female35,
        data: 35,
        position: '100% 55%'
    },
    {
        id:4,
        text: "Around 20%",
        img:female20,
        data: 20,
        position: '100% 65%'
    },
    {
        id:5,
        text: "Around 10% ",
        img: female10,
        data: 10,
        position: '100% 85%'
    },
    
]